export const buenamuerte = {
	nombre: "Buena Muerte",
	dia: "Viernes Santo",
	nombrecompleto:
		"Cofradía de Penitencia del Santísimo Cristo de la Buena Muerte y María Santísima del Mayor Dolor",
	sede: "Parroquia de San Agustín",
	pasos: 2,
	distancia: [642, 1430],
	penitentes: 175,
	cargadores: 100,
	web:
		"http://www.diariodecadiz.es/semana_santa/Buena-Muerte_0_1229577736.html",

	ida: [
		{ lng: -6.294075, lat: 36.5322485 },
		{ lng: -6.2939791, lat: 36.5322951 },
		{ lng: -6.2937203, lat: 36.5319621 },
		{ lng: -6.2922169, lat: 36.5302982 },
		{ lng: -6.2927654, lat: 36.5298424 },
		{ lng: -6.2931001, lat: 36.5297955 },
		{ lng: -6.2933113, lat: 36.5297314 },
		{ lng: -6.2936479, lat: 36.5297023 },
		{ lng: -6.2945256, lat: 36.5296344 },
		{ lng: -6.2946095, lat: 36.5295541 },
		{ lng: -6.2948696, lat: 36.5296129 },
		{ lng: -6.2951204, lat: 36.5296344 },
		// CATEDRAL
		{ lng: -6.29535, lat: 36.52899 }
	],
	vuelta: [
		{ lng: -6.29535, lat: 36.52899 },
		{ lng: -6.2956998, lat: 36.5291031 },
		{ lng: -6.2954101, lat: 36.5297497 },
		{ lng: -6.2956622, lat: 36.5299588 },
		{ lng: -6.295284, lat: 36.5303403 },
		{ lng: -6.2950104, lat: 36.5308424 },
		{ lng: -6.2949193, lat: 36.5308468 },
		{ lng: -6.29493, lat: 36.5314588 },
		{ lng: -6.2964508, lat: 36.5317735 },
		{ lng: -6.2964106, lat: 36.531864 },
		{ lng: -6.2967941, lat: 36.5325537 },
		{ lng: -6.2971227, lat: 36.533044 },
		{ lng: -6.2984772, lat: 36.5343414 },
		{ lng: -6.2977074, lat: 36.5350612 },
		{ lng: -6.296951, lat: 36.53478 },
		{ lng: -6.2967163, lat: 36.5346938 },
		{ lng: -6.2963328, lat: 36.5343177 },
		{ lng: -6.2959023, lat: 36.533821 },
		{ lng: -6.2956072, lat: 36.5334923 },
		{ lng: -6.2947516, lat: 36.5325462 },
		{ lng: -6.2943694, lat: 36.5327305 },
		{ lng: -6.2940871, lat: 36.5324217 },
		{ lng: -6.2940023, lat: 36.5323202 },
		{ lng: -6.2940918, lat: 36.5322703 }
		// ...
	],
	markers: [
		{
			name: "Salida",
			hora: "2018-03-30T21:20",
			latlng: [36.53224, -6.29407]
		},
		{
			name: "Nueva",
			hora: "2018-03-30T21:45",
			latlng: [36.53062, -6.29249]
		},
		{
			name: "Catedral",
			hora: "2018-03-30T22:35",
			latlng: [36.52899, -6.29535]
		},
		{
			name: "Candelaria",
			hora: "2018-03-30T23:25",
			latlng: [36.53106, -6.295]
		},
		{
			name: "Palillero",
			hora: "2018-03-30T23:55",
			latlng: [36.53196, -6.2965]
		},
		{
			name: "Valverde Barrié",
			hora: "2018-03-30T00:05",
			latlng: [36.53254, -6.29679]
		}
	],
	itinerario: [
		["Plaza de San Agustín", "San Francisco", "Nueva"],
		[
			"Plaza San Juan de Dios",
			"Pelota",
			"Plaza Pio XII",
			"Estación de Penitencia en la S.I.C."
		],
		[
			"Arquitecto Acero",
			"Plaza de Pío XII",
			"Compañía",
			"Santiago",
			"Plaza Candelaria"
		],
		["Montañes", "Palillero"],
		["Novena", "Ancha"],
		[
			"San Jose (dcha.)",
			"Plaza de Mina",
			"Tinte",
			"Plaza de San Francisco",
			"Rosario",
			"Marqués de Valdeiñigo",
			"San Francisco (dcha.)",
			"Plaza de San Agustín"
		]
	],
	mapConfig: {
		center: [36.5311, -6.29721],
		zoom: 17
	}
};



// WEBPACK FOOTER //
// ./src/data/procesiones/buenamuerte.js